// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2-nkQ","upload":"Small_upload__316EW","imageWrap":"Small_imageWrap__1KhfO","removeBtn":"Small_removeBtn__1M3Cg"};